"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TokenRelation = require("./TokenRelation");
var _seedRelatedMap$color, _seedRelatedMap$color2, _seedRelatedAlias$col, _seedRelatedAlias$col2;
var category = [{
  name: '颜色',
  nameEn: 'Color',
  desc: '',
  descEn: '',
  groups: [{
    key: 'brandColor',
    type: 'Color',
    name: '品牌色',
    nameEn: 'Brand Color',
    desc: '代表品牌身份、品牌形象和品牌价值观的颜色',
    descEn: '',
    seedToken: ['colorPrimary'],
    mapToken: _TokenRelation.seedRelatedMap.colorPrimary,
    aliasToken: _TokenRelation.seedRelatedAlias.colorPrimary
  }, {
    key: 'successColor',
    type: 'Color',
    name: '成功色',
    nameEn: 'Success Color',
    desc: '表示成功、完成或者达成目标等积极意义的颜色',
    descEn: '',
    seedToken: ['colorSuccess'],
    mapToken: _TokenRelation.seedRelatedMap.colorSuccess,
    aliasToken: _TokenRelation.seedRelatedAlias.colorSuccess
  }, {
    key: 'warningColor',
    type: 'Color',
    name: '警戒色',
    nameEn: 'Warning Color',
    desc: '表示警示、提醒等负面信息的颜色',
    descEn: '',
    seedToken: ['colorWarning'],
    mapToken: _TokenRelation.seedRelatedMap.colorWarning,
    aliasToken: _TokenRelation.seedRelatedAlias.colorWarning
  }, {
    key: 'errorColor',
    type: 'Color',
    name: '错误色',
    nameEn: 'Error Color',
    desc: '表示失败、未完成或者错误等负面信息的颜色',
    descEn: '',
    seedToken: ['colorError'],
    mapToken: _TokenRelation.seedRelatedMap.colorError,
    aliasToken: _TokenRelation.seedRelatedAlias.colorError
  }, {
    key: 'infoColor',
    type: 'Color',
    name: '信息色',
    nameEn: 'Info Color',
    desc: '表示信息、引导等中性信息的颜色',
    descEn: '',
    seedToken: ['colorInfo'],
    mapToken: _TokenRelation.seedRelatedMap.colorInfo,
    aliasToken: _TokenRelation.seedRelatedAlias.colorInfo
  }, {
    key: 'linkColor',
    type: 'Color',
    name: '链接色',
    nameEn: 'Link Color',
    desc: '表示链接的颜色，默认跟随信息色',
    descEn: '',
    seedToken: ['colorLink'],
    mapToken: _TokenRelation.seedRelatedMap.colorLink,
    aliasToken: _TokenRelation.seedRelatedAlias.colorLink
  }, {
    key: 'neutralColor',
    type: 'Color',
    name: '中性色',
    nameEn: 'Neutral Color',
    desc: '中性色主要被大量的应用在界面的文字、背景、边框和填充的 4 种场景。合理地选择中性色能够令页面信息具备良好的主次关系，助力阅读体验。',
    descEn: '',
    seedToken: ['colorTextBase', 'colorBgBase'],
    mapToken: (_seedRelatedMap$color = _TokenRelation.seedRelatedMap.colorTextBase) === null || _seedRelatedMap$color === void 0 ? void 0 : _seedRelatedMap$color.concat((_seedRelatedMap$color2 = _TokenRelation.seedRelatedMap.colorBgBase) !== null && _seedRelatedMap$color2 !== void 0 ? _seedRelatedMap$color2 : []),
    aliasToken: (_seedRelatedAlias$col = _TokenRelation.seedRelatedAlias.colorTextBase) === null || _seedRelatedAlias$col === void 0 ? void 0 : _seedRelatedAlias$col.concat((_seedRelatedAlias$col2 = _TokenRelation.seedRelatedAlias.colorBgBase) !== null && _seedRelatedAlias$col2 !== void 0 ? _seedRelatedAlias$col2 : []),
    aliasTokenDescription: '你可以利用 Alias Token 来精准控制部分组件的效果。例如 Input 、InputNumber、Select 等Control 类组件都共享了相同的 controlXX token 。只需修改值，即可实现不改变 Button 的情况下，修改 Control 类组件的效果。',
    mapTokenGroups: ['text', 'border', 'fill', 'background']
  }]
}, {
  name: '尺寸',
  nameEn: 'Size',
  desc: '',
  descEn: '',
  groups: [{
    key: 'font',
    name: '文字',
    nameEn: 'Font',
    desc: '',
    descEn: '',
    seedToken: ['fontSize'],
    groups: [{
      key: 'fontSize',
      type: 'FontSize',
      name: '字号',
      nameEn: 'Font Size',
      desc: '',
      descEn: '',
      mapToken: ['fontSize', 'fontSizeSM', 'fontSizeLG', 'fontSizeXL', 'fontSizeHeading1', 'fontSizeHeading2', 'fontSizeHeading3', 'fontSizeHeading4', 'fontSizeHeading5'],
      aliasToken: ['fontSizeIcon']
    }, {
      key: 'lineHeight',
      type: 'LineHeight',
      name: '行高',
      nameEn: 'Line Height',
      desc: '',
      descEn: '',
      mapToken: ['lineHeight', 'lineHeightSM', 'lineHeightLG', 'lineHeightHeading1', 'lineHeightHeading2', 'lineHeightHeading3', 'lineHeightHeading4', 'lineHeightHeading5']
    }]
  }, {
    key: 'spacing',
    name: '间距',
    nameEn: 'Spacing',
    desc: '',
    descEn: '',
    seedToken: ['sizeStep', 'sizeUnit'],
    groups: [{
      key: 'margin',
      type: 'Margin',
      name: '外间距',
      nameEn: 'Margin',
      desc: '',
      descEn: '',
      mapToken: ['marginXXS', 'marginXS', 'marginSM', 'margin', 'marginMD', 'marginLG', 'marginXL', 'marginXXL']
    }, {
      key: 'padding',
      type: 'Padding',
      name: '内间距',
      nameEn: 'Padding',
      desc: '',
      descEn: '',
      mapToken: ['paddingXXS', 'paddingXS', 'paddingSM', 'padding', 'paddingMD', 'paddingLG', 'paddingXL'],
      aliasToken: ['paddingContentHorizontal', 'paddingContentVertical', 'paddingContentHorizontalSM', 'paddingContentVerticalSM', 'paddingContentHorizontalLG', 'paddingContentVerticalLG']
    }]
  }]
}, {
  name: '风格',
  nameEn: 'Style',
  desc: '',
  descEn: '',
  groups: [{
    key: 'borderRadius',
    type: 'BorderRadius',
    name: '圆角',
    nameEn: 'Border Radius',
    desc: '',
    descEn: '',
    seedToken: ['borderRadius'],
    mapToken: ['borderRadiusXS', 'borderRadiusSM', 'borderRadius', 'borderRadiusLG']
  }, {
    key: 'boxShadow',
    type: 'BoxShadow',
    name: '阴影',
    nameEn: 'Shadow',
    desc: '',
    descEn: '',
    mapToken: ['boxShadow', 'boxShadowSecondary']
  }, {
    key: 'other',
    type: 'other',
    name: '线框化',
    nameEn: 'Wireframe',
    desc: '',
    descEn: '',
    seedToken: ['wireframe']
  }]
}];
var _default = exports.default = category;